import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import { usertourService } from '@/services/usertour.service';
import type { CreateScheduleRequest, ServiceVendorId, EmployeeId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, employeeScheduleKeys, toast } from '@petseo/shared';

interface CreateScheduleParams {
  serviceVendorId: ServiceVendorId;
  serviceVendorEmployeeId: EmployeeId;
  data: CreateScheduleRequest;
}

export const useCreateSchedule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ serviceVendorId, serviceVendorEmployeeId, data }: CreateScheduleParams) => {
      const response = await serviceVendorsClient.postScheduleEndpoint(data, String(serviceVendorId), String(serviceVendorEmployeeId));
      return response.data;
    },
    onSuccess: (_, { serviceVendorId, serviceVendorEmployeeId }) => {
      queryClient.invalidateQueries({ queryKey: employeeScheduleKeys.forEmployee(serviceVendorId, serviceVendorEmployeeId) });
      toast.success(TOAST_MESSAGES.SCHEDULE_SAVED);
      usertourService.track('schedule_created', { service_vendor_id: String(serviceVendorId) });
    },
    onError: () => toast.error(TOAST_MESSAGES.SCHEDULE_SAVE_ERROR),
  });
};
